import PropTypes from "prop-types";
import {useParams} from "react-router-dom";
import ActionContent from "components/helpers/action-text/content";
import Loading from "components/pages/loading";
import useUnknown from "lib/hooks/use-unknown";
import Links from "./links";

function Content({id = null}) {
  const params = useParams();
  const unknown = useUnknown(id || params.id);

  if(!unknown) { return <Loading />; }

  return (
    <div className="max-w-screen-md mx-auto">
      <h1>Content</h1>
      <div className="custom-html">
        <ActionContent className="mb-4" html={unknown.content || "There is no content yet for this unknown"} />
      </div>
      <Links />
    </div>
  );
}

Content.propTypes = {id: PropTypes.number};

export default Content;
